import gql from 'graphql-tag';

export const registerCertificateOfStudiesProcedure = gql`
  mutation registerCertificateType01(
    $procedureId: Float!
    $period: String!
    $periodDesc: String!
    $program: String!
    $weightedAverage: String!
    $hasDebts: Boolean
  ) {
    registerCertificateOfStudiesProcedure(
      procedureId: $procedureId
      period: $period
      periodDesc: $periodDesc
      program: $program
      weightedAverage: $weightedAverage
      hasDebts: $hasDebts
    ) {
      error
      requestId
    }
  }
`;

export const activateCertificateOfStudiesProcedure = gql`
  mutation activateCertificateType01(
    $procedureId: Float!
    $requestId: Float!
    $career: String!
  ) {
    activateCertificateOfStudiesProcedure(
      career: $career
      requestId: $requestId
      procedureId: $procedureId
    ) {
      error
      requestId
    }
  }
`;

export const downloadSimpleFile = gql`
  mutation downloadSimpleFile($key: String!) {
    download(key: $key)
  }
`;

export const paymentsStatusVerification = gql`
  query paymentsStatusVerification($requestId: Float!) {
    paymentsVerification(requestId: $requestId) {
      paymentsStatus
    }
  }
`;
